/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './app/routes/__root'
import { Route as SignupRouteImport } from './app/routes/signup'
import { Route as LoginRouteImport } from './app/routes/login'
import { Route as AuthRouteImport } from './app/routes/_auth'
import { Route as IndexRouteImport } from './app/routes/index'
import { Route as AuthCallbackRouteImport } from './app/routes/auth.callback'
import { Route as AuthPaymentsRouteImport } from './app/routes/_auth/payments'
import { Route as AuthMonetizationDashboardRouteImport } from './app/routes/_auth/monetization-dashboard'
import { Route as AuthInvoicesRouteImport } from './app/routes/_auth/invoices'
import { Route as AuthFeaturesRouteImport } from './app/routes/_auth/features'
import { Route as AuthDashboardRouteImport } from './app/routes/_auth/dashboard'
import { Route as AuthCustomersRouteImport } from './app/routes/_auth/customers'
import { Route as AuthCatalogRouteImport } from './app/routes/_auth/catalog'
import { Route as AuthAgentsRouteImport } from './app/routes/_auth/agents'
import { Route as AuthFeaturesIndexRouteImport } from './app/routes/_auth/features/index'
import { Route as AuthCustomersIndexRouteImport } from './app/routes/_auth/customers/index'
import { Route as AuthContractsIndexRouteImport } from './app/routes/_auth/contracts/index'
import { Route as AuthAgentsIndexRouteImport } from './app/routes/_auth/agents/index'
import { Route as AuthSettingsTeamRouteImport } from './app/routes/_auth/settings/team'
import { Route as AuthSettingsProfileRouteImport } from './app/routes/_auth/settings/profile'
import { Route as AuthSettingsBillingRouteImport } from './app/routes/_auth/settings/billing'
import { Route as AuthSettingsActivityRouteImport } from './app/routes/_auth/settings/activity'
import { Route as AuthSettingsAccountRouteImport } from './app/routes/_auth/settings/account'
import { Route as AuthInvoiceDetailInvoiceIdRouteImport } from './app/routes/_auth/invoice-detail.$invoiceId'
import { Route as AuthFeaturesFeatureIdRouteImport } from './app/routes/_auth/features/$featureId'
import { Route as AuthDevelopersWebhooksRouteImport } from './app/routes/_auth/developers/webhooks'
import { Route as AuthDevelopersSignalsRouteImport } from './app/routes/_auth/developers/signals'
import { Route as AuthDevelopersIntegrationsRouteImport } from './app/routes/_auth/developers/integrations'
import { Route as AuthDevelopersApiKeysRouteImport } from './app/routes/_auth/developers/api-keys'
import { Route as AuthCustomersCreateRouteImport } from './app/routes/_auth/customers/create'
import { Route as AuthCustomersCustomerIdRouteImport } from './app/routes/_auth/customers/$customerId'
import { Route as AuthContractsCreateRouteImport } from './app/routes/_auth/contracts/create'
import { Route as AuthContractsContractIdRouteImport } from './app/routes/_auth/contracts/$contractId'
import { Route as AuthAgentsAgentIdRouteImport } from './app/routes/_auth/agents/$agentId'
import { Route as AuthCustomersCustomerIdIndexRouteImport } from './app/routes/_auth/customers/$customerId/index'
import { Route as AuthCatalogTaxesIndexRouteImport } from './app/routes/_auth/catalog/taxes/index'
import { Route as AuthCatalogPlansIndexRouteImport } from './app/routes/_auth/catalog/plans/index'
import { Route as AuthCatalogCouponsIndexRouteImport } from './app/routes/_auth/catalog/coupons/index'
import { Route as AuthCatalogAddonsIndexRouteImport } from './app/routes/_auth/catalog/addons/index'
import { Route as AuthCatalogAddOnsIndexRouteImport } from './app/routes/_auth/catalog/add-ons/index'
import { Route as AuthCatalogPlansPlanIdRouteImport } from './app/routes/_auth/catalog/plans/$planId'
import { Route as AuthCatalogCouponsCreateRouteImport } from './app/routes/_auth/catalog/coupons/create'
import { Route as AuthCatalogAddOnsCreateRouteImport } from './app/routes/_auth/catalog/add-ons/create'
import { Route as AuthCatalogAddOnsAddonIdRouteImport } from './app/routes/_auth/catalog/add-ons/$addonId'
import { Route as AuthCustomersCustomerIdInvoicesInvoiceIdRouteImport } from './app/routes/_auth/customers/$customerId/invoices/$invoiceId'
import { Route as AuthCustomersCustomerIdContractsCreateRouteImport } from './app/routes/_auth/customers/$customerId/contracts/create'
import { Route as AuthCustomersCustomerIdContractsContractIdRouteImport } from './app/routes/_auth/customers/$customerId/contracts/$contractId'

const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthPaymentsRoute = AuthPaymentsRouteImport.update({
  id: '/payments',
  path: '/payments',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMonetizationDashboardRoute =
  AuthMonetizationDashboardRouteImport.update({
    id: '/monetization-dashboard',
    path: '/monetization-dashboard',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthInvoicesRoute = AuthInvoicesRouteImport.update({
  id: '/invoices',
  path: '/invoices',
  getParentRoute: () => AuthRoute,
} as any)
const AuthFeaturesRoute = AuthFeaturesRouteImport.update({
  id: '/features',
  path: '/features',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDashboardRoute = AuthDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCustomersRoute = AuthCustomersRouteImport.update({
  id: '/customers',
  path: '/customers',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCatalogRoute = AuthCatalogRouteImport.update({
  id: '/catalog',
  path: '/catalog',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAgentsRoute = AuthAgentsRouteImport.update({
  id: '/agents',
  path: '/agents',
  getParentRoute: () => AuthRoute,
} as any)
const AuthFeaturesIndexRoute = AuthFeaturesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthFeaturesRoute,
} as any)
const AuthCustomersIndexRoute = AuthCustomersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthCustomersRoute,
} as any)
const AuthContractsIndexRoute = AuthContractsIndexRouteImport.update({
  id: '/contracts/',
  path: '/contracts/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAgentsIndexRoute = AuthAgentsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthAgentsRoute,
} as any)
const AuthSettingsTeamRoute = AuthSettingsTeamRouteImport.update({
  id: '/settings/team',
  path: '/settings/team',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettingsProfileRoute = AuthSettingsProfileRouteImport.update({
  id: '/settings/profile',
  path: '/settings/profile',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettingsBillingRoute = AuthSettingsBillingRouteImport.update({
  id: '/settings/billing',
  path: '/settings/billing',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettingsActivityRoute = AuthSettingsActivityRouteImport.update({
  id: '/settings/activity',
  path: '/settings/activity',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettingsAccountRoute = AuthSettingsAccountRouteImport.update({
  id: '/settings/account',
  path: '/settings/account',
  getParentRoute: () => AuthRoute,
} as any)
const AuthInvoiceDetailInvoiceIdRoute =
  AuthInvoiceDetailInvoiceIdRouteImport.update({
    id: '/invoice-detail/$invoiceId',
    path: '/invoice-detail/$invoiceId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthFeaturesFeatureIdRoute = AuthFeaturesFeatureIdRouteImport.update({
  id: '/$featureId',
  path: '/$featureId',
  getParentRoute: () => AuthFeaturesRoute,
} as any)
const AuthDevelopersWebhooksRoute = AuthDevelopersWebhooksRouteImport.update({
  id: '/developers/webhooks',
  path: '/developers/webhooks',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDevelopersSignalsRoute = AuthDevelopersSignalsRouteImport.update({
  id: '/developers/signals',
  path: '/developers/signals',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDevelopersIntegrationsRoute =
  AuthDevelopersIntegrationsRouteImport.update({
    id: '/developers/integrations',
    path: '/developers/integrations',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthDevelopersApiKeysRoute = AuthDevelopersApiKeysRouteImport.update({
  id: '/developers/api-keys',
  path: '/developers/api-keys',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCustomersCreateRoute = AuthCustomersCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => AuthCustomersRoute,
} as any)
const AuthCustomersCustomerIdRoute = AuthCustomersCustomerIdRouteImport.update({
  id: '/$customerId',
  path: '/$customerId',
  getParentRoute: () => AuthCustomersRoute,
} as any)
const AuthContractsCreateRoute = AuthContractsCreateRouteImport.update({
  id: '/contracts/create',
  path: '/contracts/create',
  getParentRoute: () => AuthRoute,
} as any)
const AuthContractsContractIdRoute = AuthContractsContractIdRouteImport.update({
  id: '/contracts/$contractId',
  path: '/contracts/$contractId',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAgentsAgentIdRoute = AuthAgentsAgentIdRouteImport.update({
  id: '/$agentId',
  path: '/$agentId',
  getParentRoute: () => AuthAgentsRoute,
} as any)
const AuthCustomersCustomerIdIndexRoute =
  AuthCustomersCustomerIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthCustomersCustomerIdRoute,
  } as any)
const AuthCatalogTaxesIndexRoute = AuthCatalogTaxesIndexRouteImport.update({
  id: '/taxes/',
  path: '/taxes/',
  getParentRoute: () => AuthCatalogRoute,
} as any)
const AuthCatalogPlansIndexRoute = AuthCatalogPlansIndexRouteImport.update({
  id: '/plans/',
  path: '/plans/',
  getParentRoute: () => AuthCatalogRoute,
} as any)
const AuthCatalogCouponsIndexRoute = AuthCatalogCouponsIndexRouteImport.update({
  id: '/coupons/',
  path: '/coupons/',
  getParentRoute: () => AuthCatalogRoute,
} as any)
const AuthCatalogAddonsIndexRoute = AuthCatalogAddonsIndexRouteImport.update({
  id: '/addons/',
  path: '/addons/',
  getParentRoute: () => AuthCatalogRoute,
} as any)
const AuthCatalogAddOnsIndexRoute = AuthCatalogAddOnsIndexRouteImport.update({
  id: '/add-ons/',
  path: '/add-ons/',
  getParentRoute: () => AuthCatalogRoute,
} as any)
const AuthCatalogPlansPlanIdRoute = AuthCatalogPlansPlanIdRouteImport.update({
  id: '/plans/$planId',
  path: '/plans/$planId',
  getParentRoute: () => AuthCatalogRoute,
} as any)
const AuthCatalogCouponsCreateRoute =
  AuthCatalogCouponsCreateRouteImport.update({
    id: '/coupons/create',
    path: '/coupons/create',
    getParentRoute: () => AuthCatalogRoute,
  } as any)
const AuthCatalogAddOnsCreateRoute = AuthCatalogAddOnsCreateRouteImport.update({
  id: '/add-ons/create',
  path: '/add-ons/create',
  getParentRoute: () => AuthCatalogRoute,
} as any)
const AuthCatalogAddOnsAddonIdRoute =
  AuthCatalogAddOnsAddonIdRouteImport.update({
    id: '/add-ons/$addonId',
    path: '/add-ons/$addonId',
    getParentRoute: () => AuthCatalogRoute,
  } as any)
const AuthCustomersCustomerIdInvoicesInvoiceIdRoute =
  AuthCustomersCustomerIdInvoicesInvoiceIdRouteImport.update({
    id: '/invoices/$invoiceId',
    path: '/invoices/$invoiceId',
    getParentRoute: () => AuthCustomersCustomerIdRoute,
  } as any)
const AuthCustomersCustomerIdContractsCreateRoute =
  AuthCustomersCustomerIdContractsCreateRouteImport.update({
    id: '/contracts/create',
    path: '/contracts/create',
    getParentRoute: () => AuthCustomersCustomerIdRoute,
  } as any)
const AuthCustomersCustomerIdContractsContractIdRoute =
  AuthCustomersCustomerIdContractsContractIdRouteImport.update({
    id: '/contracts/$contractId',
    path: '/contracts/$contractId',
    getParentRoute: () => AuthCustomersCustomerIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/agents': typeof AuthAgentsRouteWithChildren
  '/catalog': typeof AuthCatalogRouteWithChildren
  '/customers': typeof AuthCustomersRouteWithChildren
  '/dashboard': typeof AuthDashboardRoute
  '/features': typeof AuthFeaturesRouteWithChildren
  '/invoices': typeof AuthInvoicesRoute
  '/monetization-dashboard': typeof AuthMonetizationDashboardRoute
  '/payments': typeof AuthPaymentsRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/agents/$agentId': typeof AuthAgentsAgentIdRoute
  '/contracts/$contractId': typeof AuthContractsContractIdRoute
  '/contracts/create': typeof AuthContractsCreateRoute
  '/customers/$customerId': typeof AuthCustomersCustomerIdRouteWithChildren
  '/customers/create': typeof AuthCustomersCreateRoute
  '/developers/api-keys': typeof AuthDevelopersApiKeysRoute
  '/developers/integrations': typeof AuthDevelopersIntegrationsRoute
  '/developers/signals': typeof AuthDevelopersSignalsRoute
  '/developers/webhooks': typeof AuthDevelopersWebhooksRoute
  '/features/$featureId': typeof AuthFeaturesFeatureIdRoute
  '/invoice-detail/$invoiceId': typeof AuthInvoiceDetailInvoiceIdRoute
  '/settings/account': typeof AuthSettingsAccountRoute
  '/settings/activity': typeof AuthSettingsActivityRoute
  '/settings/billing': typeof AuthSettingsBillingRoute
  '/settings/profile': typeof AuthSettingsProfileRoute
  '/settings/team': typeof AuthSettingsTeamRoute
  '/agents/': typeof AuthAgentsIndexRoute
  '/contracts/': typeof AuthContractsIndexRoute
  '/customers/': typeof AuthCustomersIndexRoute
  '/features/': typeof AuthFeaturesIndexRoute
  '/catalog/add-ons/$addonId': typeof AuthCatalogAddOnsAddonIdRoute
  '/catalog/add-ons/create': typeof AuthCatalogAddOnsCreateRoute
  '/catalog/coupons/create': typeof AuthCatalogCouponsCreateRoute
  '/catalog/plans/$planId': typeof AuthCatalogPlansPlanIdRoute
  '/catalog/add-ons/': typeof AuthCatalogAddOnsIndexRoute
  '/catalog/addons/': typeof AuthCatalogAddonsIndexRoute
  '/catalog/coupons/': typeof AuthCatalogCouponsIndexRoute
  '/catalog/plans/': typeof AuthCatalogPlansIndexRoute
  '/catalog/taxes/': typeof AuthCatalogTaxesIndexRoute
  '/customers/$customerId/': typeof AuthCustomersCustomerIdIndexRoute
  '/customers/$customerId/contracts/$contractId': typeof AuthCustomersCustomerIdContractsContractIdRoute
  '/customers/$customerId/contracts/create': typeof AuthCustomersCustomerIdContractsCreateRoute
  '/customers/$customerId/invoices/$invoiceId': typeof AuthCustomersCustomerIdInvoicesInvoiceIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/catalog': typeof AuthCatalogRouteWithChildren
  '/dashboard': typeof AuthDashboardRoute
  '/invoices': typeof AuthInvoicesRoute
  '/monetization-dashboard': typeof AuthMonetizationDashboardRoute
  '/payments': typeof AuthPaymentsRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/agents/$agentId': typeof AuthAgentsAgentIdRoute
  '/contracts/$contractId': typeof AuthContractsContractIdRoute
  '/contracts/create': typeof AuthContractsCreateRoute
  '/customers/create': typeof AuthCustomersCreateRoute
  '/developers/api-keys': typeof AuthDevelopersApiKeysRoute
  '/developers/integrations': typeof AuthDevelopersIntegrationsRoute
  '/developers/signals': typeof AuthDevelopersSignalsRoute
  '/developers/webhooks': typeof AuthDevelopersWebhooksRoute
  '/features/$featureId': typeof AuthFeaturesFeatureIdRoute
  '/invoice-detail/$invoiceId': typeof AuthInvoiceDetailInvoiceIdRoute
  '/settings/account': typeof AuthSettingsAccountRoute
  '/settings/activity': typeof AuthSettingsActivityRoute
  '/settings/billing': typeof AuthSettingsBillingRoute
  '/settings/profile': typeof AuthSettingsProfileRoute
  '/settings/team': typeof AuthSettingsTeamRoute
  '/agents': typeof AuthAgentsIndexRoute
  '/contracts': typeof AuthContractsIndexRoute
  '/customers': typeof AuthCustomersIndexRoute
  '/features': typeof AuthFeaturesIndexRoute
  '/catalog/add-ons/$addonId': typeof AuthCatalogAddOnsAddonIdRoute
  '/catalog/add-ons/create': typeof AuthCatalogAddOnsCreateRoute
  '/catalog/coupons/create': typeof AuthCatalogCouponsCreateRoute
  '/catalog/plans/$planId': typeof AuthCatalogPlansPlanIdRoute
  '/catalog/add-ons': typeof AuthCatalogAddOnsIndexRoute
  '/catalog/addons': typeof AuthCatalogAddonsIndexRoute
  '/catalog/coupons': typeof AuthCatalogCouponsIndexRoute
  '/catalog/plans': typeof AuthCatalogPlansIndexRoute
  '/catalog/taxes': typeof AuthCatalogTaxesIndexRoute
  '/customers/$customerId': typeof AuthCustomersCustomerIdIndexRoute
  '/customers/$customerId/contracts/$contractId': typeof AuthCustomersCustomerIdContractsContractIdRoute
  '/customers/$customerId/contracts/create': typeof AuthCustomersCustomerIdContractsCreateRoute
  '/customers/$customerId/invoices/$invoiceId': typeof AuthCustomersCustomerIdInvoicesInvoiceIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/_auth/agents': typeof AuthAgentsRouteWithChildren
  '/_auth/catalog': typeof AuthCatalogRouteWithChildren
  '/_auth/customers': typeof AuthCustomersRouteWithChildren
  '/_auth/dashboard': typeof AuthDashboardRoute
  '/_auth/features': typeof AuthFeaturesRouteWithChildren
  '/_auth/invoices': typeof AuthInvoicesRoute
  '/_auth/monetization-dashboard': typeof AuthMonetizationDashboardRoute
  '/_auth/payments': typeof AuthPaymentsRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/_auth/agents/$agentId': typeof AuthAgentsAgentIdRoute
  '/_auth/contracts/$contractId': typeof AuthContractsContractIdRoute
  '/_auth/contracts/create': typeof AuthContractsCreateRoute
  '/_auth/customers/$customerId': typeof AuthCustomersCustomerIdRouteWithChildren
  '/_auth/customers/create': typeof AuthCustomersCreateRoute
  '/_auth/developers/api-keys': typeof AuthDevelopersApiKeysRoute
  '/_auth/developers/integrations': typeof AuthDevelopersIntegrationsRoute
  '/_auth/developers/signals': typeof AuthDevelopersSignalsRoute
  '/_auth/developers/webhooks': typeof AuthDevelopersWebhooksRoute
  '/_auth/features/$featureId': typeof AuthFeaturesFeatureIdRoute
  '/_auth/invoice-detail/$invoiceId': typeof AuthInvoiceDetailInvoiceIdRoute
  '/_auth/settings/account': typeof AuthSettingsAccountRoute
  '/_auth/settings/activity': typeof AuthSettingsActivityRoute
  '/_auth/settings/billing': typeof AuthSettingsBillingRoute
  '/_auth/settings/profile': typeof AuthSettingsProfileRoute
  '/_auth/settings/team': typeof AuthSettingsTeamRoute
  '/_auth/agents/': typeof AuthAgentsIndexRoute
  '/_auth/contracts/': typeof AuthContractsIndexRoute
  '/_auth/customers/': typeof AuthCustomersIndexRoute
  '/_auth/features/': typeof AuthFeaturesIndexRoute
  '/_auth/catalog/add-ons/$addonId': typeof AuthCatalogAddOnsAddonIdRoute
  '/_auth/catalog/add-ons/create': typeof AuthCatalogAddOnsCreateRoute
  '/_auth/catalog/coupons/create': typeof AuthCatalogCouponsCreateRoute
  '/_auth/catalog/plans/$planId': typeof AuthCatalogPlansPlanIdRoute
  '/_auth/catalog/add-ons/': typeof AuthCatalogAddOnsIndexRoute
  '/_auth/catalog/addons/': typeof AuthCatalogAddonsIndexRoute
  '/_auth/catalog/coupons/': typeof AuthCatalogCouponsIndexRoute
  '/_auth/catalog/plans/': typeof AuthCatalogPlansIndexRoute
  '/_auth/catalog/taxes/': typeof AuthCatalogTaxesIndexRoute
  '/_auth/customers/$customerId/': typeof AuthCustomersCustomerIdIndexRoute
  '/_auth/customers/$customerId/contracts/$contractId': typeof AuthCustomersCustomerIdContractsContractIdRoute
  '/_auth/customers/$customerId/contracts/create': typeof AuthCustomersCustomerIdContractsCreateRoute
  '/_auth/customers/$customerId/invoices/$invoiceId': typeof AuthCustomersCustomerIdInvoicesInvoiceIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/signup'
    | '/agents'
    | '/catalog'
    | '/customers'
    | '/dashboard'
    | '/features'
    | '/invoices'
    | '/monetization-dashboard'
    | '/payments'
    | '/auth/callback'
    | '/agents/$agentId'
    | '/contracts/$contractId'
    | '/contracts/create'
    | '/customers/$customerId'
    | '/customers/create'
    | '/developers/api-keys'
    | '/developers/integrations'
    | '/developers/signals'
    | '/developers/webhooks'
    | '/features/$featureId'
    | '/invoice-detail/$invoiceId'
    | '/settings/account'
    | '/settings/activity'
    | '/settings/billing'
    | '/settings/profile'
    | '/settings/team'
    | '/agents/'
    | '/contracts/'
    | '/customers/'
    | '/features/'
    | '/catalog/add-ons/$addonId'
    | '/catalog/add-ons/create'
    | '/catalog/coupons/create'
    | '/catalog/plans/$planId'
    | '/catalog/add-ons/'
    | '/catalog/addons/'
    | '/catalog/coupons/'
    | '/catalog/plans/'
    | '/catalog/taxes/'
    | '/customers/$customerId/'
    | '/customers/$customerId/contracts/$contractId'
    | '/customers/$customerId/contracts/create'
    | '/customers/$customerId/invoices/$invoiceId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/signup'
    | '/catalog'
    | '/dashboard'
    | '/invoices'
    | '/monetization-dashboard'
    | '/payments'
    | '/auth/callback'
    | '/agents/$agentId'
    | '/contracts/$contractId'
    | '/contracts/create'
    | '/customers/create'
    | '/developers/api-keys'
    | '/developers/integrations'
    | '/developers/signals'
    | '/developers/webhooks'
    | '/features/$featureId'
    | '/invoice-detail/$invoiceId'
    | '/settings/account'
    | '/settings/activity'
    | '/settings/billing'
    | '/settings/profile'
    | '/settings/team'
    | '/agents'
    | '/contracts'
    | '/customers'
    | '/features'
    | '/catalog/add-ons/$addonId'
    | '/catalog/add-ons/create'
    | '/catalog/coupons/create'
    | '/catalog/plans/$planId'
    | '/catalog/add-ons'
    | '/catalog/addons'
    | '/catalog/coupons'
    | '/catalog/plans'
    | '/catalog/taxes'
    | '/customers/$customerId'
    | '/customers/$customerId/contracts/$contractId'
    | '/customers/$customerId/contracts/create'
    | '/customers/$customerId/invoices/$invoiceId'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/login'
    | '/signup'
    | '/_auth/agents'
    | '/_auth/catalog'
    | '/_auth/customers'
    | '/_auth/dashboard'
    | '/_auth/features'
    | '/_auth/invoices'
    | '/_auth/monetization-dashboard'
    | '/_auth/payments'
    | '/auth/callback'
    | '/_auth/agents/$agentId'
    | '/_auth/contracts/$contractId'
    | '/_auth/contracts/create'
    | '/_auth/customers/$customerId'
    | '/_auth/customers/create'
    | '/_auth/developers/api-keys'
    | '/_auth/developers/integrations'
    | '/_auth/developers/signals'
    | '/_auth/developers/webhooks'
    | '/_auth/features/$featureId'
    | '/_auth/invoice-detail/$invoiceId'
    | '/_auth/settings/account'
    | '/_auth/settings/activity'
    | '/_auth/settings/billing'
    | '/_auth/settings/profile'
    | '/_auth/settings/team'
    | '/_auth/agents/'
    | '/_auth/contracts/'
    | '/_auth/customers/'
    | '/_auth/features/'
    | '/_auth/catalog/add-ons/$addonId'
    | '/_auth/catalog/add-ons/create'
    | '/_auth/catalog/coupons/create'
    | '/_auth/catalog/plans/$planId'
    | '/_auth/catalog/add-ons/'
    | '/_auth/catalog/addons/'
    | '/_auth/catalog/coupons/'
    | '/_auth/catalog/plans/'
    | '/_auth/catalog/taxes/'
    | '/_auth/customers/$customerId/'
    | '/_auth/customers/$customerId/contracts/$contractId'
    | '/_auth/customers/$customerId/contracts/create'
    | '/_auth/customers/$customerId/invoices/$invoiceId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  LoginRoute: typeof LoginRoute
  SignupRoute: typeof SignupRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/payments': {
      id: '/_auth/payments'
      path: '/payments'
      fullPath: '/payments'
      preLoaderRoute: typeof AuthPaymentsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/monetization-dashboard': {
      id: '/_auth/monetization-dashboard'
      path: '/monetization-dashboard'
      fullPath: '/monetization-dashboard'
      preLoaderRoute: typeof AuthMonetizationDashboardRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/invoices': {
      id: '/_auth/invoices'
      path: '/invoices'
      fullPath: '/invoices'
      preLoaderRoute: typeof AuthInvoicesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/features': {
      id: '/_auth/features'
      path: '/features'
      fullPath: '/features'
      preLoaderRoute: typeof AuthFeaturesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/dashboard': {
      id: '/_auth/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthDashboardRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/customers': {
      id: '/_auth/customers'
      path: '/customers'
      fullPath: '/customers'
      preLoaderRoute: typeof AuthCustomersRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/catalog': {
      id: '/_auth/catalog'
      path: '/catalog'
      fullPath: '/catalog'
      preLoaderRoute: typeof AuthCatalogRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/agents': {
      id: '/_auth/agents'
      path: '/agents'
      fullPath: '/agents'
      preLoaderRoute: typeof AuthAgentsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/features/': {
      id: '/_auth/features/'
      path: '/'
      fullPath: '/features/'
      preLoaderRoute: typeof AuthFeaturesIndexRouteImport
      parentRoute: typeof AuthFeaturesRoute
    }
    '/_auth/customers/': {
      id: '/_auth/customers/'
      path: '/'
      fullPath: '/customers/'
      preLoaderRoute: typeof AuthCustomersIndexRouteImport
      parentRoute: typeof AuthCustomersRoute
    }
    '/_auth/contracts/': {
      id: '/_auth/contracts/'
      path: '/contracts'
      fullPath: '/contracts/'
      preLoaderRoute: typeof AuthContractsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/agents/': {
      id: '/_auth/agents/'
      path: '/'
      fullPath: '/agents/'
      preLoaderRoute: typeof AuthAgentsIndexRouteImport
      parentRoute: typeof AuthAgentsRoute
    }
    '/_auth/settings/team': {
      id: '/_auth/settings/team'
      path: '/settings/team'
      fullPath: '/settings/team'
      preLoaderRoute: typeof AuthSettingsTeamRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/profile': {
      id: '/_auth/settings/profile'
      path: '/settings/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof AuthSettingsProfileRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/billing': {
      id: '/_auth/settings/billing'
      path: '/settings/billing'
      fullPath: '/settings/billing'
      preLoaderRoute: typeof AuthSettingsBillingRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/activity': {
      id: '/_auth/settings/activity'
      path: '/settings/activity'
      fullPath: '/settings/activity'
      preLoaderRoute: typeof AuthSettingsActivityRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/account': {
      id: '/_auth/settings/account'
      path: '/settings/account'
      fullPath: '/settings/account'
      preLoaderRoute: typeof AuthSettingsAccountRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/invoice-detail/$invoiceId': {
      id: '/_auth/invoice-detail/$invoiceId'
      path: '/invoice-detail/$invoiceId'
      fullPath: '/invoice-detail/$invoiceId'
      preLoaderRoute: typeof AuthInvoiceDetailInvoiceIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/features/$featureId': {
      id: '/_auth/features/$featureId'
      path: '/$featureId'
      fullPath: '/features/$featureId'
      preLoaderRoute: typeof AuthFeaturesFeatureIdRouteImport
      parentRoute: typeof AuthFeaturesRoute
    }
    '/_auth/developers/webhooks': {
      id: '/_auth/developers/webhooks'
      path: '/developers/webhooks'
      fullPath: '/developers/webhooks'
      preLoaderRoute: typeof AuthDevelopersWebhooksRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/developers/signals': {
      id: '/_auth/developers/signals'
      path: '/developers/signals'
      fullPath: '/developers/signals'
      preLoaderRoute: typeof AuthDevelopersSignalsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/developers/integrations': {
      id: '/_auth/developers/integrations'
      path: '/developers/integrations'
      fullPath: '/developers/integrations'
      preLoaderRoute: typeof AuthDevelopersIntegrationsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/developers/api-keys': {
      id: '/_auth/developers/api-keys'
      path: '/developers/api-keys'
      fullPath: '/developers/api-keys'
      preLoaderRoute: typeof AuthDevelopersApiKeysRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/customers/create': {
      id: '/_auth/customers/create'
      path: '/create'
      fullPath: '/customers/create'
      preLoaderRoute: typeof AuthCustomersCreateRouteImport
      parentRoute: typeof AuthCustomersRoute
    }
    '/_auth/customers/$customerId': {
      id: '/_auth/customers/$customerId'
      path: '/$customerId'
      fullPath: '/customers/$customerId'
      preLoaderRoute: typeof AuthCustomersCustomerIdRouteImport
      parentRoute: typeof AuthCustomersRoute
    }
    '/_auth/contracts/create': {
      id: '/_auth/contracts/create'
      path: '/contracts/create'
      fullPath: '/contracts/create'
      preLoaderRoute: typeof AuthContractsCreateRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/contracts/$contractId': {
      id: '/_auth/contracts/$contractId'
      path: '/contracts/$contractId'
      fullPath: '/contracts/$contractId'
      preLoaderRoute: typeof AuthContractsContractIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/agents/$agentId': {
      id: '/_auth/agents/$agentId'
      path: '/$agentId'
      fullPath: '/agents/$agentId'
      preLoaderRoute: typeof AuthAgentsAgentIdRouteImport
      parentRoute: typeof AuthAgentsRoute
    }
    '/_auth/customers/$customerId/': {
      id: '/_auth/customers/$customerId/'
      path: '/'
      fullPath: '/customers/$customerId/'
      preLoaderRoute: typeof AuthCustomersCustomerIdIndexRouteImport
      parentRoute: typeof AuthCustomersCustomerIdRoute
    }
    '/_auth/catalog/taxes/': {
      id: '/_auth/catalog/taxes/'
      path: '/taxes'
      fullPath: '/catalog/taxes/'
      preLoaderRoute: typeof AuthCatalogTaxesIndexRouteImport
      parentRoute: typeof AuthCatalogRoute
    }
    '/_auth/catalog/plans/': {
      id: '/_auth/catalog/plans/'
      path: '/plans'
      fullPath: '/catalog/plans/'
      preLoaderRoute: typeof AuthCatalogPlansIndexRouteImport
      parentRoute: typeof AuthCatalogRoute
    }
    '/_auth/catalog/coupons/': {
      id: '/_auth/catalog/coupons/'
      path: '/coupons'
      fullPath: '/catalog/coupons/'
      preLoaderRoute: typeof AuthCatalogCouponsIndexRouteImport
      parentRoute: typeof AuthCatalogRoute
    }
    '/_auth/catalog/addons/': {
      id: '/_auth/catalog/addons/'
      path: '/addons'
      fullPath: '/catalog/addons/'
      preLoaderRoute: typeof AuthCatalogAddonsIndexRouteImport
      parentRoute: typeof AuthCatalogRoute
    }
    '/_auth/catalog/add-ons/': {
      id: '/_auth/catalog/add-ons/'
      path: '/add-ons'
      fullPath: '/catalog/add-ons/'
      preLoaderRoute: typeof AuthCatalogAddOnsIndexRouteImport
      parentRoute: typeof AuthCatalogRoute
    }
    '/_auth/catalog/plans/$planId': {
      id: '/_auth/catalog/plans/$planId'
      path: '/plans/$planId'
      fullPath: '/catalog/plans/$planId'
      preLoaderRoute: typeof AuthCatalogPlansPlanIdRouteImport
      parentRoute: typeof AuthCatalogRoute
    }
    '/_auth/catalog/coupons/create': {
      id: '/_auth/catalog/coupons/create'
      path: '/coupons/create'
      fullPath: '/catalog/coupons/create'
      preLoaderRoute: typeof AuthCatalogCouponsCreateRouteImport
      parentRoute: typeof AuthCatalogRoute
    }
    '/_auth/catalog/add-ons/create': {
      id: '/_auth/catalog/add-ons/create'
      path: '/add-ons/create'
      fullPath: '/catalog/add-ons/create'
      preLoaderRoute: typeof AuthCatalogAddOnsCreateRouteImport
      parentRoute: typeof AuthCatalogRoute
    }
    '/_auth/catalog/add-ons/$addonId': {
      id: '/_auth/catalog/add-ons/$addonId'
      path: '/add-ons/$addonId'
      fullPath: '/catalog/add-ons/$addonId'
      preLoaderRoute: typeof AuthCatalogAddOnsAddonIdRouteImport
      parentRoute: typeof AuthCatalogRoute
    }
    '/_auth/customers/$customerId/invoices/$invoiceId': {
      id: '/_auth/customers/$customerId/invoices/$invoiceId'
      path: '/invoices/$invoiceId'
      fullPath: '/customers/$customerId/invoices/$invoiceId'
      preLoaderRoute: typeof AuthCustomersCustomerIdInvoicesInvoiceIdRouteImport
      parentRoute: typeof AuthCustomersCustomerIdRoute
    }
    '/_auth/customers/$customerId/contracts/create': {
      id: '/_auth/customers/$customerId/contracts/create'
      path: '/contracts/create'
      fullPath: '/customers/$customerId/contracts/create'
      preLoaderRoute: typeof AuthCustomersCustomerIdContractsCreateRouteImport
      parentRoute: typeof AuthCustomersCustomerIdRoute
    }
    '/_auth/customers/$customerId/contracts/$contractId': {
      id: '/_auth/customers/$customerId/contracts/$contractId'
      path: '/contracts/$contractId'
      fullPath: '/customers/$customerId/contracts/$contractId'
      preLoaderRoute: typeof AuthCustomersCustomerIdContractsContractIdRouteImport
      parentRoute: typeof AuthCustomersCustomerIdRoute
    }
  }
}

interface AuthAgentsRouteChildren {
  AuthAgentsAgentIdRoute: typeof AuthAgentsAgentIdRoute
  AuthAgentsIndexRoute: typeof AuthAgentsIndexRoute
}

const AuthAgentsRouteChildren: AuthAgentsRouteChildren = {
  AuthAgentsAgentIdRoute: AuthAgentsAgentIdRoute,
  AuthAgentsIndexRoute: AuthAgentsIndexRoute,
}

const AuthAgentsRouteWithChildren = AuthAgentsRoute._addFileChildren(
  AuthAgentsRouteChildren,
)

interface AuthCatalogRouteChildren {
  AuthCatalogAddOnsAddonIdRoute: typeof AuthCatalogAddOnsAddonIdRoute
  AuthCatalogAddOnsCreateRoute: typeof AuthCatalogAddOnsCreateRoute
  AuthCatalogCouponsCreateRoute: typeof AuthCatalogCouponsCreateRoute
  AuthCatalogPlansPlanIdRoute: typeof AuthCatalogPlansPlanIdRoute
  AuthCatalogAddOnsIndexRoute: typeof AuthCatalogAddOnsIndexRoute
  AuthCatalogAddonsIndexRoute: typeof AuthCatalogAddonsIndexRoute
  AuthCatalogCouponsIndexRoute: typeof AuthCatalogCouponsIndexRoute
  AuthCatalogPlansIndexRoute: typeof AuthCatalogPlansIndexRoute
  AuthCatalogTaxesIndexRoute: typeof AuthCatalogTaxesIndexRoute
}

const AuthCatalogRouteChildren: AuthCatalogRouteChildren = {
  AuthCatalogAddOnsAddonIdRoute: AuthCatalogAddOnsAddonIdRoute,
  AuthCatalogAddOnsCreateRoute: AuthCatalogAddOnsCreateRoute,
  AuthCatalogCouponsCreateRoute: AuthCatalogCouponsCreateRoute,
  AuthCatalogPlansPlanIdRoute: AuthCatalogPlansPlanIdRoute,
  AuthCatalogAddOnsIndexRoute: AuthCatalogAddOnsIndexRoute,
  AuthCatalogAddonsIndexRoute: AuthCatalogAddonsIndexRoute,
  AuthCatalogCouponsIndexRoute: AuthCatalogCouponsIndexRoute,
  AuthCatalogPlansIndexRoute: AuthCatalogPlansIndexRoute,
  AuthCatalogTaxesIndexRoute: AuthCatalogTaxesIndexRoute,
}

const AuthCatalogRouteWithChildren = AuthCatalogRoute._addFileChildren(
  AuthCatalogRouteChildren,
)

interface AuthCustomersCustomerIdRouteChildren {
  AuthCustomersCustomerIdIndexRoute: typeof AuthCustomersCustomerIdIndexRoute
  AuthCustomersCustomerIdContractsContractIdRoute: typeof AuthCustomersCustomerIdContractsContractIdRoute
  AuthCustomersCustomerIdContractsCreateRoute: typeof AuthCustomersCustomerIdContractsCreateRoute
  AuthCustomersCustomerIdInvoicesInvoiceIdRoute: typeof AuthCustomersCustomerIdInvoicesInvoiceIdRoute
}

const AuthCustomersCustomerIdRouteChildren: AuthCustomersCustomerIdRouteChildren =
  {
    AuthCustomersCustomerIdIndexRoute: AuthCustomersCustomerIdIndexRoute,
    AuthCustomersCustomerIdContractsContractIdRoute:
      AuthCustomersCustomerIdContractsContractIdRoute,
    AuthCustomersCustomerIdContractsCreateRoute:
      AuthCustomersCustomerIdContractsCreateRoute,
    AuthCustomersCustomerIdInvoicesInvoiceIdRoute:
      AuthCustomersCustomerIdInvoicesInvoiceIdRoute,
  }

const AuthCustomersCustomerIdRouteWithChildren =
  AuthCustomersCustomerIdRoute._addFileChildren(
    AuthCustomersCustomerIdRouteChildren,
  )

interface AuthCustomersRouteChildren {
  AuthCustomersCustomerIdRoute: typeof AuthCustomersCustomerIdRouteWithChildren
  AuthCustomersCreateRoute: typeof AuthCustomersCreateRoute
  AuthCustomersIndexRoute: typeof AuthCustomersIndexRoute
}

const AuthCustomersRouteChildren: AuthCustomersRouteChildren = {
  AuthCustomersCustomerIdRoute: AuthCustomersCustomerIdRouteWithChildren,
  AuthCustomersCreateRoute: AuthCustomersCreateRoute,
  AuthCustomersIndexRoute: AuthCustomersIndexRoute,
}

const AuthCustomersRouteWithChildren = AuthCustomersRoute._addFileChildren(
  AuthCustomersRouteChildren,
)

interface AuthFeaturesRouteChildren {
  AuthFeaturesFeatureIdRoute: typeof AuthFeaturesFeatureIdRoute
  AuthFeaturesIndexRoute: typeof AuthFeaturesIndexRoute
}

const AuthFeaturesRouteChildren: AuthFeaturesRouteChildren = {
  AuthFeaturesFeatureIdRoute: AuthFeaturesFeatureIdRoute,
  AuthFeaturesIndexRoute: AuthFeaturesIndexRoute,
}

const AuthFeaturesRouteWithChildren = AuthFeaturesRoute._addFileChildren(
  AuthFeaturesRouteChildren,
)

interface AuthRouteChildren {
  AuthAgentsRoute: typeof AuthAgentsRouteWithChildren
  AuthCatalogRoute: typeof AuthCatalogRouteWithChildren
  AuthCustomersRoute: typeof AuthCustomersRouteWithChildren
  AuthDashboardRoute: typeof AuthDashboardRoute
  AuthFeaturesRoute: typeof AuthFeaturesRouteWithChildren
  AuthInvoicesRoute: typeof AuthInvoicesRoute
  AuthMonetizationDashboardRoute: typeof AuthMonetizationDashboardRoute
  AuthPaymentsRoute: typeof AuthPaymentsRoute
  AuthContractsContractIdRoute: typeof AuthContractsContractIdRoute
  AuthContractsCreateRoute: typeof AuthContractsCreateRoute
  AuthDevelopersApiKeysRoute: typeof AuthDevelopersApiKeysRoute
  AuthDevelopersIntegrationsRoute: typeof AuthDevelopersIntegrationsRoute
  AuthDevelopersSignalsRoute: typeof AuthDevelopersSignalsRoute
  AuthDevelopersWebhooksRoute: typeof AuthDevelopersWebhooksRoute
  AuthInvoiceDetailInvoiceIdRoute: typeof AuthInvoiceDetailInvoiceIdRoute
  AuthSettingsAccountRoute: typeof AuthSettingsAccountRoute
  AuthSettingsActivityRoute: typeof AuthSettingsActivityRoute
  AuthSettingsBillingRoute: typeof AuthSettingsBillingRoute
  AuthSettingsProfileRoute: typeof AuthSettingsProfileRoute
  AuthSettingsTeamRoute: typeof AuthSettingsTeamRoute
  AuthContractsIndexRoute: typeof AuthContractsIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAgentsRoute: AuthAgentsRouteWithChildren,
  AuthCatalogRoute: AuthCatalogRouteWithChildren,
  AuthCustomersRoute: AuthCustomersRouteWithChildren,
  AuthDashboardRoute: AuthDashboardRoute,
  AuthFeaturesRoute: AuthFeaturesRouteWithChildren,
  AuthInvoicesRoute: AuthInvoicesRoute,
  AuthMonetizationDashboardRoute: AuthMonetizationDashboardRoute,
  AuthPaymentsRoute: AuthPaymentsRoute,
  AuthContractsContractIdRoute: AuthContractsContractIdRoute,
  AuthContractsCreateRoute: AuthContractsCreateRoute,
  AuthDevelopersApiKeysRoute: AuthDevelopersApiKeysRoute,
  AuthDevelopersIntegrationsRoute: AuthDevelopersIntegrationsRoute,
  AuthDevelopersSignalsRoute: AuthDevelopersSignalsRoute,
  AuthDevelopersWebhooksRoute: AuthDevelopersWebhooksRoute,
  AuthInvoiceDetailInvoiceIdRoute: AuthInvoiceDetailInvoiceIdRoute,
  AuthSettingsAccountRoute: AuthSettingsAccountRoute,
  AuthSettingsActivityRoute: AuthSettingsActivityRoute,
  AuthSettingsBillingRoute: AuthSettingsBillingRoute,
  AuthSettingsProfileRoute: AuthSettingsProfileRoute,
  AuthSettingsTeamRoute: AuthSettingsTeamRoute,
  AuthContractsIndexRoute: AuthContractsIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  LoginRoute: LoginRoute,
  SignupRoute: SignupRoute,
  AuthCallbackRoute: AuthCallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
